const VenturesHeader = () => (
  <section className="relative global-container z-5 text-center flex flex-col mb-[8.65rem] items-center">
    <h1 className="h3 text-white mb-[1.2rem]">Recent Ventures</h1>
    <p className="text-white max-w-[81rem] w-full">
      Explore Dancap Group’s signature developments, from luxury residences to
      innovative commercial spaces.
    </p>
  </section>
);

export default VenturesHeader;
